import { FaLaptopCode, FaProjectDiagram } from 'react-icons/fa';

const Experience = () => (
  <>
    <h2 className="text-2xl font-semibold border-b-2 border-blue-500 dark:border-blue-300 pb-2 mb-4">Experience</h2>
    <div className="space-y-4 pr-3 mb-10">
      <div className="backdrop-blur-sm dark:bg-opacity-25 dark:bg-gray-700 p-4 rounded-lg shadow-2xl">
        <div className="flex items-center">
          <FaLaptopCode className="text-2xl text-blue-500 dark:text-blue-300 mr-3" />
          <h3 className="text-xl font-semibold">Freelance Developer</h3>
        </div>
        <p className="text-gray-300 dark:text-gray-400">Jan 2023 - Present</p>
        <ul className="list-disc space-y-3 ml-6 mt-2">
          <li>Developed and maintained web applications using React and Node.js.</li>
          <li>Collaborated with clients to design and implement custom features.</li>
          <li>Provided technical support and troubleshooting for various projects.</li>
        </ul>
      </div>
      <div className="backdrop-blur-sm dark:bg-opacity-25 dark:bg-gray-700 p-4 rounded-lg shadow-2xl">
        <div className="flex items-center">
          <FaProjectDiagram className="text-2xl text-blue-500 dark:text-blue-300 mr-3" />
          <h3 className="text-xl font-semibold">Graduation Project</h3>
        </div>
        <p className="text-gray-300 dark:text-gray-400">Sep 2023 - June 2024</p>
        <ul className="list-disc space-y-3 ml-6 mt-2">
          <li>Participated in a team of 2 students in developing a comprehensive web application.</li>
          <li>We used HTML, CSS, and JavaScript only, with no framework, to ensure our app was lightweight.</li>
          <li>Utilized WebSocket connections to transfer real-time data.</li>
          <li>Controlled hardware using our webpage, with the server running on an ESP32 microcontroller.</li>
          <li>Presented the project to faculty and received excellent feedback.</li></ul>
      </div>
    </div>
  </>
);

export default Experience;
